import React, { useEffect } from 'react';
import { Typography } from '@mui/material';
import { di } from '../../../../../../state/inversify.config';
import { AssessmentCreationViewService } from '../../../assessmentCreationView/assessmentCreation.view.service';
import { ModulesSpecsDomain } from '../modules.domain';
import { Notes } from '../../components/notes/notes.dumb';
import { Instructions } from '../../components/instructions/instructions.dumb';
import { ToggleQuestion } from '../../components/questionSet/toggleQuestion.dumb';
import { SkipModule } from '../../components/skipModule/skipModule.smart';
import { AssessmentModules } from '../../modules';
import { useCustomTranslation } from '../../../../../../translation/customTranslation';

export function BalanceTandemGait({ domainService }: any) {
  const moduleSpecsDomain = di.get<ModulesSpecsDomain>(ModulesSpecsDomain);
  const { t } = useCustomTranslation('assessment');
  const assessmentCreationViewService = di.get<AssessmentCreationViewService>(
    AssessmentCreationViewService,
  );

  const module = assessmentCreationViewService.useModuleSelector();

  const { balanceTandemGait } = module;
  const moduleName: string = 'balanceTandemGait';

  const balanceTandemGaitConvertedToString =
    moduleSpecsDomain.useResponseSelector(moduleName);

  const { heading, instructions, note, responseList } =
    moduleSpecsDomain.balanceTandemGaitExamConfig();

  const saveModule = () => {
    assessmentCreationViewService.dispatchSetAssessmentModule({
      balanceTandemGait,
    });
  };

  const saveAnswersResponse = (key: string, value: boolean | string) => {
    assessmentCreationViewService.dispatchSetAssessmentModuleDetails(
      moduleName,
      key,
      value,
    );

    moduleSpecsDomain.resetSkipModule(moduleName);
  };

  const setNotesComments = (key: string, value: string) => {
    assessmentCreationViewService.dispatchSetAssessmentModuleDetails(
      moduleName,
      key,
      value,
    );

    moduleSpecsDomain.resetSkipModule(moduleName);
  };

  useEffect(() => {
    domainService.dispatchNextEnabledAndValidate(
      balanceTandemGait,
      AssessmentModules.BalanceTandemGait,
    );
    domainService.dispatchBackEnabled(true);
    saveModule();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [balanceTandemGait]);

  return (
    <>
      <Typography variant="h6" fontWeight="bold">
        {t(heading)}
      </Typography>
      <Instructions instructions={instructions} />
      <ToggleQuestion
        questionList={responseList}
        onAnswerSelect={saveAnswersResponse}
        data={balanceTandemGait}
      />
      {note && (
        <Notes
          label={t(note.label)}
          keyValue={note.key}
          onSave={setNotesComments}
          data={balanceTandemGait?.balanceTandemGaitClinicalNotes || ''}
          fullWidth
        />
      )}
      <SkipModule
        moduleKeyValue={moduleName}
        skipModuleFlag={balanceTandemGait?.skipModuleFlag}
        skipModuleComments={balanceTandemGait?.skipModuleComments}
      />
    </>
  );
}
